/**
 * Step 3: Main Step Component - Select Countries or Sites
 *
 * Migrated from: lego/page/etmf/overview/update-study/Step3.jsx
 */

import React, { useRef } from 'react'
import Step3Selector from './Step3Selector'
import Step3Countries from './Step3Countries'
import Step3Sites from './Step3Sites'
import { useDialogContext } from './context/useDialogContext'
import type { FormValues } from './context/DialogContext'

interface Step3Props {
  values: FormValues
  setFieldValue: (field: string, value: any) => void
  setValues: (values: FormValues) => void
}

export default function Step3({ values, setFieldValue, setValues }: Step3Props) {
  const dialogData = useDialogContext()
  const reloadTable = useRef<(() => void) | null>(null)

  const reloadController = (reloadFn: () => void) => {
    reloadTable.current = reloadFn
  }

  return (
    <div className="step">
      <Step3Selector
        values={values}
        setFieldValue={setFieldValue}
        setValues={setValues}
        reloadTable={reloadTable.current}
      />
      {values.level === dialogData.levelOptions.countries ? (
        <Step3Countries values={values} setFieldValue={setFieldValue} reloadController={reloadController} />
      ) : (
        <Step3Sites values={values} setFieldValue={setFieldValue} reloadController={reloadController} />
      )}
    </div>
  )
}
